module.exports = __webpack_public_path__ + "img/CompScope_Bright_07.26cb7e5e.png";